// extracted by mini-css-extract-plugin
module.exports = {"base":"ShowcaseList-module-base"};